/** @file Editor entry: address-bar sync, keyboard shortcuts, dev test hooks, then the React shell. */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './shell/shell.css';
import { api } from './api/api';
import { App } from './shell/App';
import { installTestHooks } from './shell/installTestHooks';
import { listenHistory } from './shell/router/listenHistory';
import { navigate } from './shell/router/navigate';
import { installShortcuts } from './shell/shortcuts/installShortcuts';

listenHistory(window);
installShortcuts(window, { 'shell.openSettings': () => { navigate('/settings'); } });
if (import.meta.env.DEV || import.meta.env.MODE === 'e2e') installTestHooks(window, api);

const root = document.getElementById('root');
if (root) createRoot(root).render(<StrictMode><App /></StrictMode>);
